import { useQuery } from '@tanstack/react-query';
import { ApiError } from '@root/globalTypes';
import { queryKeys } from '@utils/consts';
import { queryFetch } from '@services/api';
import { WorkloadCalendarSidebarRespSuccess } from './types';
import { useQueryParams } from '@hooks/queryParams';
import { camelToSnakeCase } from '@utils/textHelpers';

export const useGetWorkloadCalendarSidebar = () => {
  const { params, parseParams } = useQueryParams();

  const { team, search, constructionTypes, readyToSchedule } = params;

  const queryParams = parseParams({
    search,
    constructionTypes,
    team: team?.map((el) => camelToSnakeCase(el)),
  });

  const { data, error, isFetching } = useQuery<WorkloadCalendarSidebarRespSuccess, ApiError>({
    queryKey: [...queryKeys.workloadCalendarSidebar, queryParams],
    queryFn: () => queryFetch({ url: `workloads/calendar_sidebar${queryParams}` }),
    placeholderData: (previousData) => previousData as WorkloadCalendarSidebarRespSuccess,
    enabled: Boolean(readyToSchedule),
  });

  return {
    data,
    error,
    isLoading: isFetching,
  };
};
